import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TslToastrService } from '@tesla/ng-tds';
import { Store, select } from '@ngrx/store';
import { SupplierState } from '../store/state/supplierstate.state';
import { SelectCurrentUser } from '../store/app.selector';
import { CommonService } from '../services/common.service';
import { ClearSupplierDetailsByCode, GetSupplierProfileCurrentUser } from '../store/app.actions';
import { ProfileService } from '../services/profile.service';

@Injectable()

export class HomePageGuard implements CanActivate {

    constructor(
      private router: Router,
      private store: Store<SupplierState>,
      private commonService: CommonService,
      private profileService: ProfileService,
      private toasterService: TslToastrService,
    ) { }

    canActivate(
      route: ActivatedRouteSnapshot,
    ): Observable<boolean> {
      const data = route.params;
      this.store.dispatch(new GetSupplierProfileCurrentUser());
      return this.profileService.getUserDetails().pipe(
        map(result => {
        if(result && data) {
            let supplierCode;
            let userDetails = result;
            if (data["code"]) {
                supplierCode = this.commonService.getSupplierCode(data["code"]);
            }
            if (supplierCode && userDetails) {
                this.store.dispatch(new ClearSupplierDetailsByCode());
                let redirectTo = this.commonService.getRouteFromSupplierState(userDetails, supplierCode);
                let allowList = this.commonService.getPossibleRouteFromSupplierState(userDetails, supplierCode)?.map(x => x.join("/"));
                if(allowList?.includes(route.url.map(x => x.path).join("/"))) {
                    return true;
                } else {
                    this.router.navigate(redirectTo);
                    return false;
                }
            } else {
                return false
            }
        } else {
            return false
        }
      }))
    }
}